import _ from 'underscore';
import { CWBaseModel } from 'core/models/cwBase.model';

export class CWSauveGarderPreferenceModelDelete extends CWBaseModel {

  constructor(attributes?: { [key: string]: any }, options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(attributes)) {
      options = attributes;
    }
    options = options || {};
    options.habilitationV = options.habilitationV ? options.habilitationV : "N";
    options.habilitationG = options.habilitationG ? options.habilitationG : "N";
    options.usecase = options.usecase ? options.usecase : "plequipe";
    super(attributes, options);
    this.urlRoot = (): string => {
      return Configuration.restRoot + "/rest/planning/monequipe/preference/";
    }
  }
}
